import React, { Component } from "react"
import { connect } from "react-redux"
import Menu from "components/menu"
import config from "./config"

class LitterVaccinations extends Component {
  render() {
    return <Menu {...config} {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    messages: state.intl.messages.containers.litterFeatures.litterVaccinations
  }
}

export default connect(mapStateToProps)(LitterVaccinations)
